var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { AlbumRow } from '.';
import { Divider } from '../..';
import { BPMSoundsGeneric } from '../../generic';
export var SectionRenderer = function (props) {
    var _a = useState([]), sections = _a[0], setSections = _a[1];
    useEffect(function () {
        BPMSoundsGeneric.get().getSections && BPMSoundsGeneric.get().getSections(props.location).then(function (resp) {
            setSections(resp);
        });
    }, []);
    return (React.createElement("div", null, sections.map(function (section) {
        if (section.type == 'virtual') {
            var virtualSection = (props.virtualSections || []).find(function (element) {
                if (element.props && element.props.positionIdentifier == section.name) {
                    return true;
                }
                return false;
            });
            return React.createElement(React.Fragment, { key: section.id }, virtualSection);
        }
        return React.createElement(React.Fragment, { key: section.id },
            React.createElement(AlbumRow, __assign({}, props, { viewAll: false, context: '', title: section.name, soundPackages: section.items })),
            React.createElement(Divider, null));
    })));
};
export var VirtualSection = function (props) {
    return React.createElement(React.Fragment, null, props.children);
};
//# sourceMappingURL=SectionRenderer.js.map